import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*global $*/

import React from "react";
import "./ChatBox.scss";
import ChatBoxHeader from "./ChatBoxHeader";
import ChatInput from "../ChatInput/ChatInput";
import ChatMessageList from "../ChatMessageList/ChatMessageList";
import ChatContactList from "../ChatContact/ChatContactList";
import ContactCard from "@/components/ContactCard/ContactCard";
import store from "@/store/store";
import ChatStatus from "./ChatStatus";
import { currentContactSelector, contactsInListSelector } from "@/store/chat/contacts/Selectors";
import { currentContactMessagesWithMarkerSelector, lastMessagesSelector } from "@/store/chat/messages/Selectors";
import { closeChatBox } from "@/store/chat/im/Actions";
import { Icon } from "@/assets/sprites/icon";
import { CHATBOX_WIDTH } from "../ChatApp/chatWindowPosition";
import { KEY_VALUES } from "@/consts";

var ChatBox =
/** @class */
function (_super) {
  __extends(ChatBox, _super);

  function ChatBox(props) {
    var _this = _super.call(this, props) || this;

    _this.getOwnState = function () {
      var state = store.getState();
      return {
        myself: state.imSession.myself,
        contacts: contactsInListSelector(state),
        currentContact: currentContactSelector(state),
        currentContactMessages: currentContactMessagesWithMarkerSelector(state),
        lastMessages: lastMessagesSelector(state)
      };
    };

    _this.onStoreChange = function () {
      if (_this._isMounted) {
        var newState = _this.getOwnState();

        _this.setState(newState);
      }
    };

    _this._isMounted = false; //cope with weird warning: Warning: Can't perform a React state update on an unmounted component

    _this._isFocused = false; //cope with weird warning: Warning: Can't perform a React state update on an unmounted component

    _this.closeChatBox = function () {
      console.log("close chat box");

      if (store.getState().imSession.isChatBoxOpen) {
        store.dispatch(closeChatBox());
      }
    };

    _this.myRef = /*#__PURE__*/React.createRef();
    _this.state = _this.getOwnState();
    return _this;
  }

  ChatBox.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        this.unsubscribe = store.subscribe(this.onStoreChange);
        this._isMounted = true;
        $(document).on("keydown.chatbox.fht360", function (e) {
          if (e.key === KEY_VALUES.ESCAPEKEY) {
            _this._isFocused = document.hasFocus();
          }
        });
        $(document).on("keyup.chatbox.fht360", function (e) {
          if (e.key === KEY_VALUES.ESCAPEKEY && _this._isFocused) {
            _this.closeChatBox();
          }
        });
        return [2
        /*return*/
        ];
      });
    });
  };

  ChatBox.prototype.componentWillUnmount = function () {
    this._isMounted = false;
    $(document).off("keyup.chatbox.fht360");
    $(document).off("keydown.chatbox.fht360");
  };

  ChatBox.prototype.render = function () {
    return _jsxs("div", __assign({
      className: "chat-box",
      ref: this.myRef,
      style: {
        width: CHATBOX_WIDTH
      }
    }, {
      children: [_jsx("div", __assign({
        className: "chat-box__close-btn",
        onClick: this.closeChatBox
      }, {
        children: _jsx("span", {
          className: "icon " + Icon["remodal-close"]
        }, void 0)
      }), void 0), _jsx("div", {
        className: "chat-box__header-draggable-area draggable-area handle"
      }, void 0), _jsx(ChatContactList, {
        store: store,
        contacts: this.state.contacts,
        currentContact: this.state.currentContact,
        lastMessages: this.state.lastMessages
      }, void 0), this.state.currentContact && _jsxs("div", __assign({
        className: "chat-box__main"
      }, {
        children: [_jsx(ChatBoxHeader, __assign({}, this.state), void 0), _jsxs("div", __assign({
          className: "chat-box__main-container"
        }, {
          children: [_jsx(ChatStatus, __assign({}, this.state), void 0), _jsx(ChatMessageList, __assign({}, this.state), void 0), _jsx(ChatInput, {
            store: store,
            contact: this.state.currentContact
          }, void 0)]
        }), void 0)]
      }), void 0), _jsx(ContactCard, {
        contact: this.state.currentContact
      }, void 0)]
    }), void 0);
  };

  return ChatBox;
}(React.Component);

export default ChatBox;